import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import Vuex from 'vuex'
Vue.use(Vuex)

import vuetify from '@/plugins/vuetify'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

import {i18n} from '@/plugins/vuei18n';

import Trend from "vuetrend"
Vue.use(Trend)

import CKEditor from '@ckeditor/ckeditor5-vue2';
Vue.use( CKEditor )

import VueLodash from 'vue-lodash'
import lodash from 'lodash'
Vue.use(VueLodash, {lodash: lodash })

const moment = require('moment')
Vue.use(require('vue-moment'), {
  moment
})

if(process.env.NODE_ENV == 'production' || process.env.NODE_ENV == 'development'){
  Vue.config.silent = true
  Vue.config.devtools = false
  Vue.config.productionTip = false
}else if(process.env.NODE_ENV == 'local') {
  Vue.config.silent = false
  Vue.config.devtools = true
  Vue.config.productionTip = true
}

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: function (h) { return h(App) }
}).$mount('#app')
